import { api } from './client.js';
import type { Store } from '../lib/store.js';

export interface CatalogItem {
  itemId: string;
  name: string;
  urls: string[];
  defaultQty: number;
  store: Store;
  createdAt: string;
}

export interface CatalogItemInput {
  name: string;
  urls?: string[];
  defaultQty?: number;
  store: Store;
}

export async function listCatalog(store: Store): Promise<CatalogItem[]> {
  const r = await api<{ items: CatalogItem[] }>(`/catalog?store=${store}`);
  return r.items;
}

export async function createCatalogItem(input: CatalogItemInput): Promise<CatalogItem> {
  const r = await api<{ item: CatalogItem }>('/catalog', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.item;
}

export async function updateCatalogItem(
  itemId: string,
  patch: Partial<CatalogItemInput>
): Promise<CatalogItem> {
  const r = await api<{ item: CatalogItem }>(`/catalog/${itemId}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.item;
}

export async function deleteCatalogItem(itemId: string): Promise<void> {
  await api<void>(`/catalog/${itemId}`, { method: 'DELETE' });
}
